import initProduct from '@sectionsJS/product-page';
import initStickyAddToCart from '@componentsJS/add-to-cart-sticky';
import Breadcrumbs from '@componentsJS/breadcrumbs';
import initCompleteTheLook from '@componentsJS/complete-the-look';
import initRecentlyViewedProducts from '@sectionsJS/recently-viewed-products';
import { initOutOfStockUpsell } from '@sectionsJS/out-of-stock-upsell';
import initSizeGuide from '@sectionsJS/size-guide';
import ProductSEO from '@sectionsJS/product-page/product-seo';

$(async () => {
  initProduct();
  new Breadcrumbs();
});

// Due to third-party library Selectric
$(window).on('load', async () => {
  initOutOfStockUpsell();
  initSizeGuide();
  initCompleteTheLook();
  initStickyAddToCart();
  initRecentlyViewedProducts();
  new ProductSEO();

  // Call events associated to sticky add to cart that might have been called from other functions before page load
  document.dispatchEvent(new Event('astr-pdp-fit-selected'));
  document.dispatchEvent(new Event('astr-pdp-color-selected'));
  document.dispatchEvent(new Event('astr-pdp-size-selected'));
  document.dispatchEvent(new Event('astr-pdp-amount-selected'));
});
